import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { TodayDataEntity } from 'src/app/models/data-entities/today-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-today-data-entity-view',
    templateUrl: './today-data-entity-view.component.html',
    styleUrls: ['./today-data-entity-view.component.css'],
    standalone: false
})
export class TodayDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService,componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService ) {
    super(layoutService, componentFactoryResolver, context);
  }
  todayEntity: TodayDataEntity;

  ngOnInit() {
    this.todayEntity = <TodayDataEntity>this.entity;
  }

  // added by Deepak 14-05-2026
  getEntityLabelText(): string {
    if (!this.entity) {
      return '';
    }
  
    let label = this.entity.label || '';
  
    // replicate required indicator
    if (this.entity.isRequired) {
      label = `${label} *`;
    }
  
    return label;
  }
  // end by Deepak 14-05-2026
}
